import React from 'react';
const HeadingLevelContext = React.createContext({
    level: 1,
});
export const useHeadingLevel = () => React.useContext(HeadingLevelContext);
export const HeadingLevelProvider = ({ level = 1, children, }) => {
    return (React.createElement(HeadingLevelContext.Provider, { value: {
            level,
        } }, children));
};
//# sourceMappingURL=HeadingLevelContext.js.map
// @zapier/design-system@6.27.0 (617a97f69)
